// @flow
import axios from 'axios';
import config from '../config';
import Raven from 'raven-js';
import { browserHistory } from 'react-router';
import {
  displayAuthenticationError,
  loginError
} from './authentication/authCreators';

export function makeAPICall(endpoint: string, options: Object) {
  const APIEndpoint = config.RMRDigitalAPI + endpoint;
  return axios(APIEndpoint, options).catch(function(error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      // return error.response;
      console.error('Error making API call (response): ', error.response);
      // Don't log unauthorised & Bad Request
      const status = error.response.status;
      const ignoredStatuses = [400, 401, 409];
      if (!ignoredStatuses.includes(status)) {
        logException(error.response.data.message, error);
      }
      return Promise.reject(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser
      // and an instance of http.ClientRequest in node.js
      console.error('Error making API call (request): ', error.message);
      logException(error.message, error);
      return Promise.reject(error);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Error making API call (unknown)', error.message);
      logException(error.message, error);
      return Promise.reject(error);
    }
  });
}

export function logException(exception: Error, context: ?Object = {}) {
  Raven.captureException(exception, { extra: context });
}

export function APIError(error: Object, message: string): any {
  return function(dispatch) {
    message = message || 'There was an error requesting data from the API.';
    console.error(message);

    if (
      error.status === 401 &&
      error.data &&
      error.data.message === 'User is not logged in'
    ) {
      dispatch(loginError(error.data.message));
    }

    if (error.status === 403) {
      dispatch(displayAuthenticationError());
    }

    return Promise.reject(error);
  };
}

export function redirectTo(url: string) {
  browserHistory.push(url);
}

export function getCurrentOrgIdByContext(context: string, getState: Function) {
  switch (context) {
    case 'customer':
      return getState().currentOrganisation.id;
    case 'sub-account':
      return getState().currentLocation.id;
    default:
      return 0;
  }
}



// WEBPACK FOOTER //
// ./src/actions/generalCreators.js